<!-- Sidebar -->
@if(enableNavbar()) {
  <div id="sidebar-wrapper" class="d-print-none">
    <ul class="sidebar-nav">
        <!-- TOGGLE MENU SVF -->
         @if(!isMf()) {
            @if(isMainMenuMinimized()) {
              <li (click)="mainMenuClick($event)" title="Visa meny">
                <a  class="main-menu-toggler"><i class="fa-regular fa-chevron-right fa-lg text-center main-menu-toggler"></i></a>
              </li>
            } @else {
              <li (click)="mainMenuClick($event)" style="text-align:right;" title="Stäng meny">
                <a  class="main-menu-toggler"><i class="fa-regular fa-chevron-left fa-lg text-center main-menu-toggler"></i></a>
              </li>
            }
          }
        <li class="mt-3" [ngClass]="{'current-active': currentActive('webquotation/catalogue/0') }" [permission]="{area: 'Web-Quotation', action: 'add'}" [attr.title]="newWebQuotationTitle()">
            <a (click)="onNewWebQuotation()" class="main-menu-item"><i class="fa-regular fa-display-medical fa-lg text-center"></i><span>{{newWebQuotationTitle()}}</span></a>
        </li>
        <li class="mt-3" [permission]="{area: 'Portal', action: 'backoffice'}">
            <a (click)="openCreateReclaim(copyWebquotationModal)" class="main-menu-item mt-2">
                <i class="fa-regular fa-copy fa-lg text-center" title="Skapa reklamation"></i><span>Skapa reklamation</span>
            </a>
        </li>
        <li class="mt-3" [ngClass]="{'current-active': currentActive('webquotations') }" [permission]="{area: 'Web-Quotation', action: 'route'}" [attr.title]="webQuotationsTitle()">
            <a [routerLink]="['webquotations']" class="main-menu-item">
                <i class="fa-regular fa-display fa-lg text-center" [attr.title]="text_snicAppSalesBasketsInNeedOfAction() == '' ? openWebQuotationsTitle() : text_snicAppSalesBasketsInNeedOfAction()"></i>
                @if(count_snicAppSalesBasketsInNeedOfAction() > 0) {
                  <div class="overlay-counter bg-warning">{{count_snicAppSalesBasketsInNeedOfAction()}}</div>
                }
                <span>{{webQuotationsTitle()}}</span>
            </a>
        </li>
        <li class="mt-3" [ngClass]="{'current-active': currentActive('/salesQuotations') }" [permission]="{ area: 'Sales-Quotation', action: 'route' }" title="Visa offerter">
            <a [routerLink]="['/salesQuotations']" class="main-menu-item"><i class="fa-regular fa-file-lines fa-lg text-center"></i><span>Offerter</span></a>
        </li>
        <li class="mt-3" [ngClass]="{'current-active': currentActive('/salesOrders') }" [permission]="{ area: 'Sales-Order', action: 'route' }" [attr.title]="count_salesOrdersInNeedOfAction() == 0 ? 'Visa ordrar' : text_salesOrdersInNeedOfAction()">
            <a [routerLink]="['/salesOrders']" class="main-menu-item">
                <i class="fa-regular fa-file-check fa-lg text-center" [attr.title]="count_salesOrdersInNeedOfAction() == 0 ? 'Visa ordrar' : text_salesOrdersInNeedOfAction()"></i>
                @if(count_salesOrdersInNeedOfAction() > 0) {
                  <div class="overlay-counter bg-warning">{{count_salesOrdersInNeedOfAction()}}</div>
                }
                <span>Ordrar</span>
            </a>
        </li>
        <li class="mt-3" [ngClass]="{'current-active': currentActive('/aftermarketIssues') }" [permission]="{ area: 'Aftermarket', action: 'route' }" title="Felanmälan">
            <a [routerLink]="['/aftermarketIssues']" class="main-menu-item"><i class="fa-regular fa-triangle-exclamation fa-lg text-center"></i><span>Felanmälan</span></a>
        </li>
        <li class="mt-3" [ngClass]="{'current-active': currentActive('/leads') }" [permission]="{ area: 'Leads', action: 'route' }" [attr.title]="text_LeadsInNeedOfAction() == '' ? 'Leads' : text_LeadsInNeedOfAction()">
            <a [routerLink]="['/leads']" class="main-menu-item">
                <i class="fa-regular fa-user fa-lg text-center" [attr.title]="text_LeadsInNeedOfAction() == '' ? 'Leads' : text_LeadsInNeedOfAction()"></i>
                @if(count_LeadsInNeedOfAction() > 0) {
                  <div class="overlay-counter bg-warning">{{count_LeadsInNeedOfAction()}}</div>
                }
                <span>Leads</span>
            </a>
        </li>
        <li class="mt-3" [ngClass]="{'current-active': currentActive('/information') }" [permission]="{ area: 'Portal', action: 'information' }" title="Information">
            <a [routerLink]="['/information']" class="main-menu-item"><i class="fa-regular fa-circle-info fa-lg text-center"></i><span>Information</span></a>
        </li>
        <li class="mt-3" [ngClass]="{'current-active': currentActive('/proffsportalen-users') }" [permission]="{ area: 'Resellers', action: 'route' }" [attr.title]="snickarAppNameUCFirst">
            <a [routerLink]="['/proffsportalen-users']" class="main-menu-item">
                <i class="fa-regular fa-mobile-button fa-lg text-center" [attr.title]="text_newSnicAppUserRelations() == '' ? snickarAppNameUCFirst : text_newSnicAppUserRelations()"></i>
                @if(count_newSnicAppUserRelations() > 0) {
                  <div class="overlay-counter bg-warning">{{count_newSnicAppUserRelations()}}</div>
                }
                <span style="white-space:nowrap">{{snickarAppNameShort}}</span>
            </a>
        </li>
        <li class="mt-3" [ngClass]="{'current-active': currentActive('/portalAdmin') }" [permission]="{ area: 'Portal', action: 'portal_admin' }" title="Portal admin">
            <a [routerLink]="['/portalAdmin']" class="main-menu-item">
                <i class="fa-regular fa-user-gear fa-lg text-center" title="Portal admin"></i><span style="white-space:nowrap">Portal admin</span>
            </a>
        </li>

        <!-- TOGGLE MENU MF -->
         @if(isMf()) {
            @if(isMainMenuMinimized()) {
              <li class="mt-3" (click)="mainMenuClick($event)" title="Visa meny">
                <a  class="main-menu-toggler" style="padding-left: 0.3rem;"><i class="fa-regular fa-chevron-right fa-lg text-center main-menu-toggler"></i></a>
              </li>
            } @else {
              <li class="mt-3" (click)="mainMenuClick($event)" style="text-align:right;" title="Stäng meny">
                <a  class="main-menu-toggler"><i class="fa-regular fa-chevron-left fa-lg text-center main-menu-toggler"></i></a>
              </li>
            }
          }
    </ul>
  </div>
}

<ng-template #copyWebquotationModal>
  <copy-webquotation [copyFromSalesBasketId]="''"
                           [createNewVersion]="false"
                           [createReclaim]="true"
                           [isReclaim]="true"
                           [currentBrand]="'CC'"
                           [salesBasketVersionName]="''"
                           [accessLevel]="1"
                           [extraSales]="false"
                           [salesBasketLines]="null"
                           [hasExternalProjectId]="false"
                           (copyWebquotationModalEvent)="copyWebquotationModalEvent($event)">

  </copy-webquotation>
</ng-template>
